import { createAction, props } from '@ngrx/store';
import { StationLongDto } from '@api/rest';

export const loadStations = createAction(
  '[Station/API] Load Stations'
);

export const loadStationsSuccess = createAction(
  '[Station/API] Load Stations Success',
  props<{ stations: StationLongDto[] }>()
);

export const loadStationsFailure = createAction(
  '[Station/API] Load Stations Failure',
  props<{ error: any }>()
);

export const getStation = createAction(
  '[Station/API] Get Station',
  props<{ id: string }>()
);

export const getStationSuccess = createAction(
  '[Station/API] get Station Success',
  props<{ station: StationLongDto }>()
);

export const getStationFailure = createAction(
  '[Station/API] Get Station Failure',
  props<{ error: any }>()
);

export const setSelectedStation = createAction(
  '[Station/API] Get Selected Station',
  props<{ id: string }>()
);

export const setSelectedSubstation = createAction(
  '[Station/API] Get Selected Substation',
  props<{ id: string }>()
);

export const addFavorite = createAction(
  '[Station/API] Add favorite',
  props<{ favorite: string }>()
);

export const removeFavorite = createAction(
  '[Station/API] Remove favorite',
  props<{ favorite: string }>()
);

export const clearFavorites = createAction(
  '[Station/API] Clear favorites'
);
